/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Share_BtnInputs */

const en_story_share_btn = /** @type {(inputs: Story_Share_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share to Story`)
};

const es_story_share_btn = /** @type {(inputs: Story_Share_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir en la Historia`)
};

const fr_story_share_btn = /** @type {(inputs: Story_Share_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager dans la Story`)
};

const de_story_share_btn = /** @type {(inputs: Story_Share_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Story teilen`)
};

const id_story_share_btn = /** @type {(inputs: Story_Share_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan ke Cerita`)
};

/** @type {(inputs: Story_Share_BtnInputs) => LocalizedString} */
const ja_story_share_btn = en_story_share_btn;

/** @type {(inputs: Story_Share_BtnInputs) => LocalizedString} */
const zh_story_share_btn = en_story_share_btn;

/** @type {(inputs: Story_Share_BtnInputs) => LocalizedString} */
const ar_story_share_btn = en_story_share_btn;

/** @type {(inputs: Story_Share_BtnInputs) => LocalizedString} */
const it_story_share_btn = en_story_share_btn;

/** @type {(inputs: Story_Share_BtnInputs) => LocalizedString} */
const ru_story_share_btn = en_story_share_btn;

/** @type {(inputs: Story_Share_BtnInputs) => LocalizedString} */
const pt_story_share_btn = en_story_share_btn;

/** @type {(inputs: Story_Share_BtnInputs) => LocalizedString} */
const ko_story_share_btn = en_story_share_btn;

/**
* | output |
* | --- |
* | "Share to Story" |
*
* @param {Story_Share_BtnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_share_btn = /** @type {((inputs?: Story_Share_BtnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Share_BtnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_share_btn(inputs)
	if (locale === "es") return es_story_share_btn(inputs)
	if (locale === "fr") return fr_story_share_btn(inputs)
	if (locale === "de") return de_story_share_btn(inputs)
	if (locale === "ja") return ja_story_share_btn(inputs)
	if (locale === "zh") return zh_story_share_btn(inputs)
	if (locale === "ar") return ar_story_share_btn(inputs)
	if (locale === "id") return id_story_share_btn(inputs)
	if (locale === "it") return it_story_share_btn(inputs)
	if (locale === "ru") return ru_story_share_btn(inputs)
	if (locale === "pt") return pt_story_share_btn(inputs)
	return ko_story_share_btn(inputs)
});